module.exports = __webpack_public_path__ + "img/ISBT.65bd84a3.png";